
import { useMediaUrlsHandler } from './media/hooks/useMediaUrlsHandler';
import type { MediaUrlsHandlerProps } from './media/hooks/useMediaUrlsHandler';

const MediaUrlsHandler = ({ mediaUrls = [], setMediaUrls, name, productId, shopId }: MediaUrlsHandlerProps) => {
  // Get the current user's organization ID from context or a custom hook
  const organizationId = "2b57f5d3-ddf7-4d15-b82a-59226fe8e94e"; // Using the org ID from console logs
  
  console.log("MediaUrlsHandler with organizationId:", organizationId);
  console.log("MediaUrlsHandler with mediaUrls:", mediaUrls);
  console.log("MediaUrlsHandler with productId:", productId);
  console.log("MediaUrlsHandler with shopId:", shopId);
  
  // Use the hook to manage media URLs
  const handler = useMediaUrlsHandler(mediaUrls, shopId, productId, organizationId);
  
  // If setMediaUrls is provided, synchronize the previewMediaUrls with it
  if (setMediaUrls) {
    const handleMediaUrlsChange = () => {
      const committedUrls = handler.commitPreviewUrls();
      console.log("Setting media URLs:", committedUrls);
      setMediaUrls(committedUrls);
    };
    
    // Add the method to the handler as a function reference
    // We'll need to update the type definition in useMediaUrlsHandler as well
    Object.assign(handler, { commitAndUpdateUrls: handleMediaUrlsChange });
  }
  
  return handler;
};

export default MediaUrlsHandler;
